import {
  ANALYTICS_EVENTS,
  AnalyticsSiteAssets,
  ContentBodyAbodeSupportAnalytics
} from '@com-delta-idp/mnx-utils';

export function processContentAnalytics(
  contentDiv: HTMLElement | null,
  contentBodyAbodeSupportAnalytics: ContentBodyAbodeSupportAnalytics,
  computePageLoadAssetID: (componentType: string, idx: number) => string
): AnalyticsSiteAssets[] {
  if (!contentDiv || !contentBodyAbodeSupportAnalytics) return [];

  try {
    const cardDivs = [
      {
        element: contentDiv.querySelector(
          '.d-flex.hero-home-text-container.flex-column'
        ),
        type: ANALYTICS_EVENTS.HERO_CLICK
      },
      {
        element: contentDiv.querySelector('.section.cardcd.card-d'),
        type: ANALYTICS_EVENTS.TILE_CLICK
      },
      ...Array.from(
        contentDiv.querySelectorAll('.cardb.parbase.container') || []
      ).map((el) => ({
        element: el,
        type: ANALYTICS_EVENTS.BANNER_CLICK
      }))
    ];

    const validCardDivs = cardDivs.filter((item) => item.element);
    let site_assets: AnalyticsSiteAssets[] = [];
    contentBodyAbodeSupportAnalytics.setupGlobalClickListener();

    const bannerElements = validCardDivs.filter(
      (item) => item.type === ANALYTICS_EVENTS.BANNER_CLICK
    );

    if (bannerElements.length > 0) {
      const totalBanners = bannerElements.length;
      bannerElements.forEach((item, idx) => {
        if (item.element) {
          const assetId = computePageLoadAssetID(item.type, idx);
          const assets =
            contentBodyAbodeSupportAnalytics.setHomePageSiteAssetsAnalytics(
              item.element,
              item.type,
              `${idx + 1} of ${totalBanners}`
            );
          if (assets?.length) {
            site_assets = [...site_assets, ...assets];
          }
        }
      });
    }

    validCardDivs
      .filter((item) => item.type !== ANALYTICS_EVENTS.BANNER_CLICK)
      .forEach((item) => {
        if (item.element) {
          const assets =
            contentBodyAbodeSupportAnalytics.setHomePageSiteAssetsAnalytics(
              item.element,
              item.type
            );
          if (assets?.length) {
            site_assets = [...site_assets, ...assets];
          }
        }
      });

    return site_assets;
  } catch (error) {
    console.error('Error processing content analytics:', error);
    return [];
  }
}
